import React, { useState, useEffect, createContext, useContext } from "react";
import "./Header.css";
import api from "../../Services/api";
import { Link, useNavigate } from "react-router-dom";
import avatar from "../../Assets/Images/avatar.png";
import { useKeycloak } from "@react-keycloak/web";
import { BurgerIcon, BurgerIconClosed } from "../../Components/IconComponents";
import { LayoutState } from "../../Context/LayoutContext/LayoutContext";
import {
  urmservice,
  userImageUpload,
  mediaFileLink,
  getThemeURL,
} from "../../Services/EndPoints";
import { useTranslation } from "react-i18next";
import ThemesPopUp from "../../Components/UiComponents/ThemesPopUp/ThemesPopUp";
import { useSelector } from "react-redux";
import { RoleContext, ThemeContext } from "../..";
import IResponse_LogoWhite from "../../Assets/Icons/IResponse_LogoWhite.svg";
import IResponse_Logo from "../../Assets/Icons/IResponse_Logo.svg";
import { getData } from "../../Services/Services";

const Header = ({ children }) => {
  const { t, i18n, ready } = useTranslation();
  const { collapsed, toggle } = LayoutState();
  const [avtarImg, setAvtarImg] = useState(null);
  const [userProfileData, setUserProfileData] = useState(null); // Add this state
  const navigate = useNavigate();
  const [roleTitle, setRoleTitle] = useState("");
  const { keycloak } = useKeycloak();
  const { profileData } = useSelector((store) => store.data);
  const { roleName } = useContext(RoleContext);
  const { theme } = useContext(ThemeContext);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  useEffect(() => {
    getUserProfileImage();
  }, []);

  const getUserProfileImage = async () => {
    try {
      const response = await getData(getThemeURL);
      console.log("RESPONSE", response);
      
      // Store the user profile data
      if (response && response[0]) {
        setUserProfileData(response[0]);
      }

      // Check if user_image exists and is not empty
      if (response[0].user_image && response[0].user_image.trim() !== "") {
        // Convert base64 to data URL for display
        const base64Image = `data:image/jpeg;base64,${response[0].user_image}`;
        setAvtarImg(base64Image);
      } else {
        // Use default avatar if no image
        setAvtarImg(avatar);
      }
    } catch (e) {
      console.error("Error fetching user profile image:", e);
      setAvtarImg(avatar);
    }
  };

  // Function to get user's full name from API response
  const getUserFullName = () => {
    if (userProfileData) {
      const firstName = userProfileData.first_name || "";
      const lastName = userProfileData.last_name || "";
      return `${firstName} ${lastName}`.trim() || "NA";
    }
    
    // Fallback to keycloak name if API data is not available
    return (keycloak.idTokenParsed && keycloak.idTokenParsed.name) 
      ? keycloak.idTokenParsed.name 
      : "NA";
  };

  return (
    <div className="header_container">
      <div className={`top__nav ${collapsed ? " collapsed" : null}`}>
        <div className="top__nav-wrapper">
          <div className="top-menu">
            {collapsed && (
              <img
                src={theme === "light" ? IResponse_Logo : IResponse_LogoWhite}
                alt="IResponse Logo"
                className="ml-4"
                style={{ height: "3.0em", width: "auto", marginLeft: "16px", marginTop: "10px" }}
              />
            )}
          </div>
          <div className="center-box">{children}</div>

          <div className="top__nav-right">
            {/* <select
              className="lngselect"
              onChange={(e) => changeLanguage(e.target.value)}
              value={i18n.language}
            >
              <option value="en">English</option>
            </select> */}

            <ThemesPopUp />
            <div className="top__nav-right">
              {profileData && (
                <div className="user-details">
                  <span className="user-name">{getUserFullName()}</span>
                  <span className="user-role">{roleName}</span>
                </div>
              )}
              <div className="profile cursor-pointer" onClick={() => {
                navigate("/userProfile");
              }}>
                <img src={avtarImg} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;